import { Employee, EmployeeDisplayTinyInfo } from '../types'
import { computeFullname } from './nameDisplayPreferencesUtil'
import { Moment } from 'moment-timezone'

export const employeeSorter = (nameDisplayPreference: string, a: Employee, b: Employee): number => {
  const aFirstname = a.chosenFirstName ? a.chosenFirstName : a.legalFirstName
  const aLastname = a.chosenLastName ? a.chosenLastName : a.legalLastName
  const bFirstname = b.chosenFirstName ? b.chosenFirstName : b.legalFirstName
  const bLastname = b.chosenLastName ? b.chosenLastName : b.legalLastName

  const aFullname = computeFullname(nameDisplayPreference, aFirstname, aLastname)
  const bFullName = computeFullname(nameDisplayPreference, bFirstname, bLastname)

  return aFullname.localeCompare(bFullName)
}

export const employeeDisplayTinyInfoSorter = (
  nameDisplayPreference: string,
  a: EmployeeDisplayTinyInfo,
  b: EmployeeDisplayTinyInfo,
): number => {
  const aFullName = computeFullname(nameDisplayPreference, a.firstName, a.lastName)
  const bFullName = computeFullname(nameDisplayPreference, b.firstName, b.lastName)
  return aFullName.localeCompare(bFullName)
}

export const labelSorter = (label1: string, label2: string, reverse = false): number =>
  reverse ? label1.localeCompare(label2) : label1.localeCompare(label2)

export const dateSorter = (dateA: Moment | undefined, dateB: Moment | undefined): number => {
  if (dateA && dateB && dateA.isBefore(dateB)) {
    return -1
  }
  if (dateA && dateB && dateA.isAfter(dateB)) {
    return 1
  }
  return 0
}
